// extracted by mini-css-extract-plugin
module.exports = {"paymentIcons":"paymentIcons_paymentIcons__g6ypz","iconContainer":"paymentIcons_iconContainer__QO1dB","withPadding":"paymentIcons_withPadding__YgeOc"};